import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@/components/ui";
import Seo from "@/components/Seo";
import { ImmersiveShell } from "@/components/immersive/ImmersiveShell";
import { Reveal } from "@/components/immersive/Reveal";
import Breadcrumbs from "@/components/immersive/Breadcrumbs";
import { CtaCluster } from "@/components/immersive/MarketingBits";

const PARAS = [
  "Caregiver matching connects families with partner home-care agencies that may have an available caregiver who fits the way your household actually works.",
  "Matching is based on your needs and preferences — care type, schedule, location, language, experience, and personality fit. We share these details with partner agencies to help identify a potential match. HomecareMatches does not employ caregivers and does not guarantee a match.",
];

const FACTORS = [
  { title: "Care needs & type", desc: "Personal care, companion care, dementia support, overnight care, and more.", icon: "activity" },
  { title: "Schedule & availability", desc: "The days, hours, and frequency that work for your family.", icon: "calendar" },
  { title: "Location", desc: "Caregivers available from partner agencies serving your area.", icon: "map-pin" },
  { title: "Language & preferences", desc: "Preferred language, cultural fit, experience, and personality.", icon: "users" },
];

export default function CaregiverMatching() {
  return (
    <ImmersiveShell>
      <Seo title="Caregiver Matching" path="/caregiver-matching"
        description="Caregiver matching based on your needs and preferences. HomecareMatches connects families with partner home-care agencies that may have available caregivers for in-home care."
        keywords="caregiver matching, find a caregiver, in-home care, senior care matching, home care services" />
      <section className="imm-mkt-hero imm-wrap" data-testid="caregiver-matching">
        <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Caregiver Matching" }]} />
        <Reveal className="imm-eyebrow" delay={80}>Caregiver matching</Reveal>
        <Reveal as="h1" delay={180}>Caregiver Matching Based on Your Needs</Reveal>
        {PARAS.map((p, i) => <Reveal key={i} as="p" delay={300 + i * 120}>{p}</Reveal>)}
      </section>

      <section className="imm-wrap" data-testid="cm-factors" style={{ paddingBottom: "6vh" }}>
        <Reveal as="h2" className="imm-svc-h2">What we match on</Reveal>
        <div style={{ marginTop: 22 }}>
          {FACTORS.map((f, i) => (
            <Reveal key={i} delay={i * 60}><div className="imm-feature"><span className="fnum"><Icon name={f.icon} size={20} /></span><div><h3>{f.title}</h3><p>{f.desc}</p></div></div></Reveal>
          ))}
        </div>
        <Reveal delay={120}><p style={{ marginTop: 20 }}><Link className="imm-inline-link" to="/how-it-works">Learn how our matching process works <Icon name="arrow-right" size={15} /></Link></p></Reveal>
      </section>

      <section className="imm-wrap" data-testid="cm-cta" style={{ paddingBottom: "8vh" }}>
        <Reveal as="h2" className="imm-svc-h2">Get matched with a caregiver</Reveal>
        <Reveal delay={80}><div style={{ marginTop: 18 }}><CtaCluster showPromo /></div></Reveal>
      </section>
    </ImmersiveShell>
  );
}
